import { useSelector } from 'react-redux'

import { getShopInventoryAPI } from '@/api/shopApi'
import { getActiveStepType } from '@/ducks/shopProgressReducer'
import { useMountEffect } from '@/hooks/mounting-hooks'

const StepPlaceholder = () => {
  const stepType = useSelector(getActiveStepType)

  useMountEffect(() => {
    test()
  })

  const test = async () => {
    await getShopInventoryAPI(1)
  }

  return (
    <div>
      <div>{stepType}</div>
    </div>
  )
}

export default StepPlaceholder
